<template>
  <div v-if="wrapshow">
    <van-calendar
      v-model="open"
      v-bind="attrs"
      @confirm="confirm"
      @cancel="close"
    />
  </div>
</template>

<script>
export default {
  data() {
    return {
      wrapshow: true,
      open: false,
      attrs: {},
    };
  },
  created() {},
  methods: {
    showPicker(opts = {}) {
      return new Promise((resolve) => {
        this.wrapshow = true;
        this.open = true;

        this.attrs = opts;
        this._resolve = resolve;
      });
    },
    close(e) {
      this.open = false;
      setTimeout(() => {
        this.wrapshow = false;
      }, 500);
    },
    confirm(e) {
      this.close();
      this._resolve(e);
    },
  },
  watch: {},
};
</script>

<style lang="scss" scoped></style>
